import {
  DeepRequired,
  FieldError,
  FieldErrorsImpl,
  FieldValues,
  GlobalError,
  UseFormRegister,
} from 'react-hook-form';
import { Button, Form, FormAlert, FormField, FormGroup, FormLabel } from '@ax/ui';
import style from '@/modules/Auth/Login/Login.module.scss';
import { Link } from 'react-router-dom';
import { PROJECT_ENVIRONMENT } from '@ax/env';
import { SupportLink } from '@/modules/Auth/Login/SupportLink.tsx';

export function PasswordForm(props: {
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  message: string;
  username: string;
  errors: Partial<FieldErrorsImpl<DeepRequired<FieldValues>>> & {
    root?: Record<string, GlobalError> & GlobalError;
  };
  register: UseFormRegister<FieldValues>;
  renderButtonContent: JSX.Element | string;
}) {
  return (
    <Form
      className={style.login__form__body}
      onSubmit={props.onSubmit}
    >
      <FormAlert message={props.message} />
      <input
        type="hidden"
        value={props.username}
        {...props.register('email')}
      />
      <FormGroup className="mb-[40px] w-[385px]">
        <FormLabel className="input__label">Password</FormLabel>
        <FormField error={props.errors.password as FieldError}>
          <input
            type="password"
            className="input"
            placeholder="**********"
            {...props.register('password', {
              required: 'Password is required',
            })}
          />
        </FormField>
        {props.errors.password && <SupportLink />}
      </FormGroup>
      <Button
        className="h-[40px] w-[385px]"
        variant="primary"
        block
      >
        {props.renderButtonContent}
      </Button>
      <div className={style.login__form__footer}>
        <span>Don't have an account?</span>
        <Link
          to={PROJECT_ENVIRONMENT.URL['signup-url']}
          className={style.login__form__footer__link}
          target="_blank"
        >
          Sign up
        </Link>
      </div>
    </Form>
  );
}
